import { computed } from 'vue'

import { useFeatureFlags, useWorkspace } from '@/features/account'

type WorkspaceRole = 'admin' | 'editor' | 'viewer'

function resolveRole(value: string | unknown[] | undefined): WorkspaceRole | null {
  if (typeof value !== 'string') return null
  return value === 'admin' || value === 'editor' || value === 'viewer' ? value : null
}

export function useCreativeAiAccess() {
  const flags = useFeatureFlags()
  const workspace = useWorkspace()

  const canEditLabels = computed(() => {
    const current = workspace.workspace.value
    const role =
      resolveRole(current?.workspace_permissions) ?? resolveRole(current?.account_permissions)
    return role !== 'viewer'
  })

  return {
    canView: computed(() => flags.checkFlag('Creative-AI')),
    canEditLabels,
  }
}
